import { Injectable, type OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import type { CalendarStatusMessage } from './calendar-status-message';

@Injectable({ providedIn: 'root' })
export class CalendarStatusService implements OnDestroy {
  private readonly messageSubject = new Subject<CalendarStatusMessage | null>();
  private hideTimeout: ReturnType<typeof setTimeout> | null = null;

  readonly message$ = this.messageSubject.asObservable();

  showSaved(): void {
    this.show({ severity: 'success', text: 'Arbeitszeit gespeichert.' });
  }

  show(message: CalendarStatusMessage): void {
    this.messageSubject.next(message);
    this.scheduleClear();
  }

  ngOnDestroy(): void {
    this.clearHideTimeout();
  }

  private scheduleClear(): void {
    this.clearHideTimeout();
    this.hideTimeout = setTimeout(() => {
      this.messageSubject.next(null);
      this.hideTimeout = null;
    }, 5000);
  }

  private clearHideTimeout(): void {
    if (!this.hideTimeout) return;
    clearTimeout(this.hideTimeout);
    this.hideTimeout = null;
  }
}
